module.exports = __webpack_public_path__ + "media/images/navigation/contact-hover-68f1486b05c73b6bc2330f3851cfdc7d.gif";